export enum Role {
  Customer = "ROLE_CUSTOMER", // Cliente
  Employee = "ROLE_EMPLOYEE", // Dipendente
  Manager = "ROLE_MANAGER" // Manager
}
